export enum ServiceBookEnum {
  SERVICEBOOKTYPE_PAPER = 'SERVICEBOOKTYPE_PAPER',
  SERVICEBOOKTYPE_ELECTRONIC = 'SERVICEBOOKTYPE_ELECTRONIC',
  SERVICEBOOKTYPE_NONE = 'SERVICEBOOKTYPE_NONE',
}
